// extracted by mini-css-extract-plugin
export default {"container":"CompanyAdmins_container__L5U+N","error":"CompanyAdmins_error__cSu2G","emptyState":"CompanyAdmins_emptyState__gX8cs"};